import React from 'react';

/*
 * StatusChip — one consistent status pill for the whole admin.
 *
 * Renders the `.pc-chip` helper classes from admin-theme.css (low-saturation bg
 * + saturated text). Replaces the ad-hoc mix of solid vs outlined MUI <Chip>
 * and inline-styled status spans across pages.
 *
 * Usage:
 *   <StatusChip label={row.PC_REP_STATUS} />          // auto-mapped by text
 *   <StatusChip label="Custom" type="warning" />       // explicit variant
 *
 * type ∈ 'success' | 'warning' | 'error' | 'info' | 'neutral' | 'premium'
 */

/* Known status vocabularies across the suite → semantic variant. */
const STATUS_MAP = {
    // success / done / paid
    success: 'success', paid: 'success', complete: 'success', completed: 'success',
    finish: 'success', finished: 'success', done: 'success', active: 'success',
    approved: 'success', delivered: 'success', received: 'success',
    'in stock': 'success', instock: 'success',
    // in-progress / awaiting
    pending: 'warning', requested: 'warning', request: 'warning',
    'in process': 'warning', 'in-process': 'warning', processing: 'warning',
    partial: 'warning', hold: 'warning',
    // failed / negative
    refund: 'error', refunded: 'error', unpaid: 'error', failed: 'error',
    error: 'error', rejected: 'error', cancelled: 'error', canceled: 'error',
    inactive: 'error',
    // informational
    available: 'info', info: 'info', new: 'info', open: 'info',
};

function resolveType(label, type) {
    if (type) return type;
    if (!label) return 'neutral';
    return STATUS_MAP[String(label).trim().toLowerCase()] || 'neutral';
}

export default function StatusChip({ label, type, className = '', style }) {
    const variant = resolveType(label, type);
    return (
        <span className={`pc-chip pc-chip--${variant} ${className}`.trim()} style={style}>
            {label != null && label !== '' ? label : 'N/A'}
        </span>
    );
}
